const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export function logout() {
	localStorage.removeItem('token')
	window.location.href = '/login'
}

export const getAuthHeaders = () => {
	const token = localStorage.getItem('token')

	if (!token) {
		throw new Error('No token found')
	}

	return {
		Authorization: `Bearer ${token}`,
		'Content-Type': 'application/json',
	}
}

export const loginWithEmail = async (email, password) => {
	const res = await fetch(`${BASE_URL}/auth/login`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ email, password }),
	})

	const data = await res.json()

	if (!res.ok) throw new Error(data.message || 'Login failed')
	return data.token
}
